import React, {Component, ReactElement} from 'react'

import NatDisasterRepo from './repository/NatDisasterRepo'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {AppAdminContext} from '../../../app/AppAdminContext'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import NatAdminDisasterCommentListForm from './admin/NatAdminDisasterCommentListForm'
import styled from 'styled-components'
import {Colors, FontWeights} from '../../../styledComponents/Constants'
import {ListAltOutlined} from '@mui/icons-material'
import {faCommentDots} from '@fortawesome/free-regular-svg-icons'
import {RowFlexContainer} from '../../../styledComponents/FlexComponents'
import {Box} from '@mui/material'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    AdminLoginInfoSessionStorageKey,
    NatAdminLoginInfoSessionStorageHelper
} from '../../common/authentication/NatAdminLoginInfoSessionStorageHelper'
import {PageFotterAreaLeft} from '../../../components/shared/hoc/withAdminPageTemplate'
import {ADMINISTORATOR_MODE} from '../../../CodeMaster'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import NatAdminDisasterTopicListForm from './admin/NatAdminDisasterTopicListForm'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    activeTab: ActiveTab
    condominiumRepo: NatCondominiumRepo
    disasterRepo: NatDisasterRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
}

type ActiveTab = 'comments' | 'topics'

class NatAdminDisasterTopicListPage extends Component<Props & AdminPagePropsSet, States> {
    mode: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)
        this.mode = NatAdminLoginInfoSessionStorageHelper
            .getStringItemOrNull(AdminLoginInfoSessionStorageKey.SELECTED_MODE)
    }

    async componentDidMount(): Promise<void> {
        this.showInitialMessage();
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage;
        this.props.navigate(this.props.location.pathname, {replace: true, state: {}});
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage);
    }

    onChangeActiveTab(tab: ActiveTab): void {
        this.props.eventEmitter.clearHeadingAreaMessage();
        this.props.navigate(`/admin/condominiums/${this.props.condominiumCd}/disasters/${tab}`)
    }

    render(): Nullable<ReactElement> {
        const {activeTab} = this.props
        return (
            <>
                <TabWrapper>
                    <Tab
                        className={activeTab === 'comments' ? 'active' : ''}
                        onClick={() => this.onChangeActiveTab('comments')}
                    >
                        <FontAwesomeIcon icon={faCommentDots} style={{fontSize: '20px'}}/>
                        <Box ml={'5px'}>コメント表示</Box>
                    </Tab>
                    <Tab className={activeTab === 'topics' ? 'active' : ''}
                         onClick={() => this.onChangeActiveTab('topics')}
                    >
                        <ListAltOutlined/>
                        <Box ml={'5px'}>トピック表示</Box>
                    </Tab>
                </TabWrapper>
                {activeTab === 'comments' &&
                    <NatAdminDisasterCommentListForm
                        {...this.props}
                    />
                }
                {activeTab === 'topics' &&
                    <NatAdminDisasterTopicListForm
                        {...this.props}
                    />
                }
                {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                    <>
                        <Box height={'10px'}/>
                        <PageFotterAreaLeft>
                            <BackLink
                                to={`/admin/disasters/mode/statuses`}
                            >
                                モード設定状況一覧へ戻る
                            </BackLink>
                        </PageFotterAreaLeft>
                    </>
                }
            </>
        )
    }
}

NatAdminDisasterTopicListPage.contextType = AppAdminContext
export default createAdminPage(NatAdminDisasterTopicListPage)

const TabWrapper = styled.div`
    display: flex;
    border-bottom: 2px solid ${Colors.AccentLight};
`

const Tab = styled(RowFlexContainer)`
    padding: 13px 25px;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.54);
    position: relative;

    &.active {
        color: ${Colors.AdminPrimary};
        font-weight: ${FontWeights.Bold};
    }

    &.active::after {
        content: '';
        position: absolute;
        width: 100%;
        left: 0;
        bottom: -2px;
        height: 2px;
        background-color: ${Colors.AdminPrimary};
    }
`
